module.exports = __webpack_public_path__ + "static/media/Hoopa_gaussian2.afc159f3.png";